import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-store-home-feed",
  "use": "icon-soc-store-home-feed-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-store-home-feed\">\r\n<g fill=\"currentColor\">\r\n<rect x=\"160\" y=\"200\" width=\"420\" height=\"280\" rx=\"24\" />\r\n<rect x=\"620\" y=\"200\" width=\"244\" height=\"128\" rx=\"20\" />\r\n<rect x=\"620\" y=\"352\" width=\"244\" height=\"128\" rx=\"20\" />\r\n<rect x=\"160\" y=\"520\" width=\"200\" height=\"200\" rx=\"20\" />\r\n<rect x=\"392\" y=\"520\" width=\"200\" height=\"200\" rx=\"20\" />\r\n<rect x=\"624\" y=\"520\" width=\"240\" height=\"200\" rx=\"20\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-store-home-feed.svg
// module id = 33h9
// module chunks = 546